import React from "react";

import { CloseConfirmation } from "@/design-system/components/CloseConfirmation/CloseConfirmation";

export type WizardReset = "discard" | "restart";

type WizardResetConfirmationProps = {
  pending: WizardReset | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function WizardResetConfirmation({
  pending,
  onCancel,
  onConfirm,
}: WizardResetConfirmationProps) {
  return (
    <CloseConfirmation
      open={pending !== null}
      title={
        pending === "restart"
          ? "Start this wizard over?"
          : "Discard this wizard?"
      }
      description="Your progress will be lost. Anything you already saved, like a connected destination, stays as it is. Minimize instead to pick up where you left off."
      confirmLabel={pending === "restart" ? "Start over" : "Discard"}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
